import { createContext, use } from 'react';
import invariant from 'tiny-invariant';

import type { Auth0Client } from '@auth0/auth0-spa-js';

export interface Auth0ContextValue {
	client: Auth0Client;
}

export const Auth0Context = createContext<Auth0ContextValue | null>(null);

export function useAuth0Context() {
	const context = use(Auth0Context);
	invariant(context, 'Auth0Context not provided');
	return context;
}
